<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';

import { randomId } from '@/library/message/lib';

import baguetteBox from './Lightbox.lib';

const generatedId = ref<string>('');

const initBaguetteBox = () => {
  const selector = `div[data-baguette-box="${generatedId.value}"]`;
  baguetteBox.run(selector, {
    noScrollbars: true,
    filter: /^(blob:[^'"]+|[^\s]+\.(jpe?g|png))$/i,
  });
};

onMounted(async () => {
  generatedId.value = `${randomId(10)}-${randomId(10)}-image`;

  setTimeout(() => {
    initBaguetteBox();
  }, 1000);
});

onBeforeUnmount(() => {
  const selector = `div[data-baguette-box="${generatedId.value}"]`;
  baguetteBox.destroyOne(selector);
});
</script>

<template>
  <div :data-baguette-box="generatedId">
    <slot />
  </div>
</template>
